module.exports = __webpack_public_path__ + "assets/images/rbyearend-17-desktop.jpg?v=08e15914";